{
  "addRevenue": "+ Add income",
  "recordMenu": "Record",
  "recordMenuIncome": "Add income",
  "recordMenuExpense": "Add expense",
  "dashboard": {
    "title": "Bookkeeping",
    "subtitle": "Track income, expenses, and profit by period.",
    "kpi": {
      "income": "Income",
      "incomeSplit": "invoices {{fromInvoices}} · other {{other}}",
      "expenses": "Expenses",
      "netProfit": "Net Profit",
      "expensesCount": "{{count}} expenses"
    },
    "sourceBreakdown": {
      "title": "Income by Source",
      "empty": "No income in this period yet."
    },
    "categoryBreakdown": {
      "title": "Expenses by Category",
      "empty": "No expenses in this period yet.",
      "count": "{{count}} entries",
      "addFirst": "Add an expense"
    },
    "viewAll": "View all →",
    "viewIncome": "View income"
  },
  "export": {
    "button": "Download bookkeeping",
    "downloading": "Downloading...",
    "success": "Downloaded",
    "error": "Download failed",
    "form": {
      "report": "Revenue report",
      "s1a": "Revenue book",
      "s2": "Detailed revenue & expense ledger",
      "misa": "Export for MISA"
    },
    "disclaimer": "Books/reports are generated from your LopHoc data (tuition and expenses you've entered). Please reconcile against your actual filing obligations."
  },
  "period": {
    "month": "Month",
    "quarter": "Quarter",
    "year": "Year",
    "label": {
      "month": "{{month}}/{{year}}",
      "quarter": "Q{{quarter}}/{{year}}",
      "year": "{{year}}"
    },
    "prev": "Previous",
    "next": "Next"
  },
  "expenses": {
    "title": "Expenses",
    "subtitle": "All expense entries.",
    "add": "Add expense",
    "search": "Search by vendor...",
    "filter": {
      "all": "All"
    },
    "empty": {
      "title": "No expenses yet",
      "subtitle": "Record rent, wages and purchases so the books show the real profit.",
      "cta": "Record an expense",
      "filtered": "No expenses match the filter."
    },
    "table": {
      "date": "Date",
      "vendor": "Vendor",
      "client": "Client",
      "category": "Category",
      "amount": "Amount",
      "notes": "Notes",
      "receipt": "Receipt"
    }
  },
  "income": {
    "title": "Income",
    "subtitle": "Money actually received in this period.",
    "empty": "No income in this period yet.",
    "emptyTitle": "No income recorded yet",
    "emptyBody": "Money from invoices and hand-entered receipts both land here.",
    "col": {
      "date": "Date",
      "content": "Description",
      "source": "Source",
      "invoice": "Invoice / client",
      "amount": "Amount"
    },
    "source": {
      "SEPAY": "Bank transfer (QR)",
      "CASH": "Cash",
      "MANUAL_BANK": "External bank transfer",
      "ECOMMERCE": "Marketplace",
      "OTHER": "Other"
    },
    "loading": "Loading..."
  },
  "drawer": {
    "create": {
      "title": "Add expense",
      "subtitle": "Enter the expense details below."
    },
    "edit": {
      "title": "Edit expense"
    },
    "field": {
      "amount": "Amount (VND) *",
      "amountPlaceholder": "1,250,000",
      "category": "Category *",
      "date": "Date *",
      "vendor": "Vendor",
      "vendorPlaceholder": "Store / supplier name",
      "client": "Client",
      "noClient": "— No client —",
      "notes": "Notes",
      "notesPlaceholder": "Additional details..."
    },
    "category": {
      "custom": "+ Custom",
      "customPlaceholder": "Type a category..."
    },
    "cancel": "Cancel",
    "save": "Save",
    "saving": "Saving...",
    "saveChanges": "Save changes",
    "delete": "Delete",
    "deleteConfirm": {
      "title": "Delete expense?",
      "body": "This action cannot be undone.",
      "action": "Delete"
    }
  },
  "toast": {
    "created": "Expense added",
    "updated": "Updated",
    "deleted": "Expense deleted",
    "error": "Something went wrong"
  },
  "locked": {
    "title": "Upgrade to Pro to use Bookkeeping",
    "body": "Your current plan doesn't include writing to the ledger — you can still view, download, and delete your own data. Upgrade to Pro to record new income/expenses and see profit analysis.",
    "cta": "Upgrade",
    "upsellTitle": "Recording and editing need Pro",
    "upsellBody": "You can still view, export and delete your own bookkeeping on every plan. Upgrade to Pro to record new income/expenses and edit existing ones."
  }
}
